module.exports = __webpack_public_path__ + "img/finish.f1585b74.png";